/**
 * Marketing / legal URLs on x9.app — same paths as native AppInfo.js.
 */

export const X9_MARKETING_BASE_URL = 'https://x9.app';

/** Same inbox native's Contact support row opens (`AppInfo.SUPPORT_EMAIL`). */
export const SUPPORT_EMAIL = 'support@x9.app';

const MARKETING_LOCALE_BY_APP: Record<string, string> = {
  en: 'en',
  pt: 'pt-br',
  'pt-BR': 'pt-br',
  'pt-br': 'pt-br',
};

export function detectAppLocale(): string {
  if (typeof navigator === 'undefined') return 'en';
  const lang = (navigator.language || 'en').toLowerCase();
  if (lang.startsWith('pt')) return 'pt';
  return 'en';
}

export function getMarketingLocale(appLocale: string): string {
  return MARKETING_LOCALE_BY_APP[appLocale] || 'en';
}

export function getLocalizedMarketingUrl(appLocale: string, path = ''): string {
  const locale = getMarketingLocale(appLocale);
  const normalizedPath = path && !path.startsWith('/') ? `/${path}` : path;
  return `${X9_MARKETING_BASE_URL}/${locale}${normalizedPath}`;
}

export function getTermsUrl(appLocale = detectAppLocale()): string {
  return getLocalizedMarketingUrl(appLocale, '/legal/terms');
}

export function getPrivacyUrl(appLocale = detectAppLocale()): string {
  return getLocalizedMarketingUrl(appLocale, '/legal/privacy');
}

export function getHelpUrl(appLocale = detectAppLocale()): string {
  return getLocalizedMarketingUrl(appLocale, '/help');
}
